// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3qc_x","consentsList":"PatientConsents_consentsList__fhcQi","consentsListEmpty":"PatientConsents_consentsListEmpty__3vJVX"};